import { useEffect } from "react";

const BASE = "Diotech";

export default function useDocumentTitle(section) {
  useEffect(() => {
    const prev = document.title;
    document.title = section ? `${BASE} | ${section}` : BASE;
    return () => { document.title = prev; };
  }, [section]);
}
